module.exports = require("parsleyjs/src/i18n/zh_cn.extra");